import { CommonSettings } from '../interfaces';
import { NotificationsService } from '../services';
import { useSettingsStore } from './useSettingsStore';

/**
 * Custom hook to get the NotificationsService instance from the settings.
 * This hook uses the `useSettingsStore` hook to access the state and retrieve the NotificationsService instance.
 *
 * @template T - The type of the notifications.
 * @returns {NotificationsService<T>} - Returns an instance of NotificationsService.
 *
 * @example
 * const notificationsService = useNotificationService<MyNotificationType>();
 * notificationsService.notify('New message received');
 */
export function useNotificationService<T>(): NotificationsService<T> {
  // Destructure the state from the useSettingsStore hook
  const { state } = useSettingsStore();

  // Get the settings from the state
  const settings: CommonSettings = state.settings;

  // Get the NotificationsService instance from the settings
  const { NotificationsService } = settings.useNotificationService();

  // Return the NotificationsService instance
  return NotificationsService;
}
